import { ViewController } from '@estee/elc-service';

import { ConfigRepository } from '~repositories/ConfigRepository';
import { computed } from 'mobx';
import { RouterStore } from '@estee/elc-router';

interface IRampMainViewController {
    routerStore: RouterStore;
    configRepository: ConfigRepository;
}

export class RampMainViewController extends ViewController {
    private configRepository: ConfigRepository;
    public routerStore: RouterStore;

    constructor({ routerStore, configRepository }: IRampMainViewController) {
        super();
        this.configRepository = configRepository;
        this.routerStore = routerStore;
    }

    @computed
    get data() {
        const {
            isConfigLoaded,
            iamConfig,
            isSetupReady,
            config: {
                config: { businessUnitId }
            }
        } = this.configRepository;

        return {
            isConfigLoaded,
            iamConfig,
            isSetupReady,
            businessUnitId,
            routerStore: this.routerStore
        };
    }
}
